// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.ucase-text input {\r\n  text-transform: uppercase;\n}\n.v-text-field--outlined {\r\n  font-size: 10pt;\n}\n.v-text-field label {\r\n  font-size: 10pt;\n}\n.checbox-decoration {\r\n  margin: 0px;\n}\n.checbox-decoration .v-label {\r\n  margin: 0px;\r\n  font-size: 10pt;\n}\r\n", ""]);
// Exports
module.exports = exports;
